// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gocase-colorpicker[data-v-cff1d190]{padding:0;margin:-10px 0 0;list-style-type:none;display:flex;flex-wrap:wrap}.gocase-colorpicker li[data-v-cff1d190]{margin-right:10px;margin-top:10px;display:block}.gocase-colorpicker li span[data-v-cff1d190]{width:44px;height:44px;border:4px solid #ddd;border-radius:50%;display:block;cursor:pointer}.gocase-colorpicker li.active span[data-v-cff1d190]{border-color:#ec3faa}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
